  const form1 = document.querySelector(".newsletterStep1");
  const form2 = document.querySelector(".newsletterStep2");
  const form3 = document.querySelector(".newsletterStep3");
  const continueBtn1 = form1.querySelector('input[type="button"]');
  const continueBtn2 = form2.querySelector('input[type="button"]');
  const skipBtn = form2.querySelector(".newsletterSkipButton");
  form2.classList.add("hidden");
  form3.classList.add("hidden");
  function showForm(formToShow, ...formsToHide) {
      formToShow.classList.remove("hidden");
      formsToHide.forEach((form) => form.classList.add("hidden"));
  }

  continueBtn1.addEventListener("click", () => {
  const emailField = document.getElementById('email');
    const emailValue = emailField.value.trim();
    const emailError = document.getElementById('error-message');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailValue) {
        emailError.textContent = 'Please enter your email address.';
        emailError.style.display = 'block';
    } else if (!emailPattern.test(emailValue)) {
        emailError.textContent = 'Please enter a valid email address.';
        emailError.style.display = 'block';
    } else {
        emailError.style.display = 'none';
        showForm(form2, form1, form3);
    }
  });
  continueBtn2.addEventListener("click", () => {
        createSubscription();
  });
  skipBtn.addEventListener("click", () => {
     createSubscriptionwithemail();
  });
  document.querySelector(".newsletterFieldsWrapper > button").addEventListener("click", function () {
      document.querySelector(".newsletterDropdown").classList.toggle("dropdownActive");
  });
  document.querySelectorAll(".newsletterDropdown > button").forEach(function (button) {
      button.addEventListener("click", function () {
          const flagIcon = this.querySelector(".flagIcon").innerHTML;
          const countryCode = this.querySelector(".countryCode").innerHTML;
          const wrapperButton = document.querySelector(".newsletterFieldsWrapper > button");
          wrapperButton.querySelector(".flagIcon").innerHTML = flagIcon;
          wrapperButton.querySelector(".countryCode").innerHTML = countryCode;
          document.querySelector(".newsletterDropdown").classList.remove("dropdownActive");
      });
  });

    document.addEventListener("DOMContentLoaded", function () {
        const body = document.body;
        const modelContainer = document.querySelector(".newsletterModalContainer");
        const modelOverlay = document.querySelector(".newsletterModalOverlay");
        const modelCloser = document.querySelector(".newsletterModalCloseButton");
        const modelCloser1 = document.querySelector(".newsletterModalClosemodel");
    modelOverlay.addEventListener('click', (e) => {
        if (e.target === modelOverlay) {
            modelOverlay.classList.remove('active');
        modelContainer.classList.remove('active');
        modelContainer.setAttribute('aria-hidden', 'true');
          modelContainer.style.opacity = "0"; 
        body.style.overflow = '';
        }
    });
        const hasVisited = localStorage.getItem("hasVisited");

    if (!hasVisited) {
    setTimeout(function() {
        modelOverlay.classList.add("active");
        modelContainer.classList.add("active");
        modelContainer.setAttribute("aria-hidden", "false");
        modelContainer.style.opacity = "1"; 
        body.style.overflow = "hidden";
        localStorage.setItem("hasVisited", "true");
    }, 6000);

    }
      modelCloser.addEventListener("click", function () {
          modelOverlay.classList.remove("active");
          modelContainer.classList.remove("active");
          modelContainer.setAttribute("aria-hidden", "true");
        modelContainer.style.opacity = "0"; 
          body.style.overflow = "";
      });
          modelCloser1.addEventListener("click", function () {
          modelOverlay.classList.remove("active");
          modelContainer.classList.remove("active");
          modelContainer.setAttribute("aria-hidden", "true");
            modelContainer.style.opacity = "0"; 
          body.style.overflow = "";
      });
  });

  document.addEventListener("DOMContentLoaded", async () => {
  const countryButton = document.getElementById("countryButton");
  const countryDropdown = document.getElementById("countryDropdown");
  async function fetchCountries() {
    try {
      const response = await fetch(window.countryDataUrl);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();

      countryDropdown.innerHTML = "";

      data.forEach((country) => {
        const flagUrl = country.flagSvg || country.flagPng;
        const countryCode = country.dialCode;
        const countryName = country.name;

        if (!flagUrl || !countryCode) return;

        const countryItem = document.createElement("button");
        countryItem.type = "button";
        countryItem.className = "dropdown-item";

        countryItem.innerHTML = `
          <img src="${flagUrl}" alt="${countryName}">
          <span class="countryCode">${countryCode}</span>
        `;

        countryItem.addEventListener("click", () => {
          document.querySelector("#countryButton .flagIcon img").src = flagUrl;
          document.querySelector("#countryButton .countryCode").textContent =
            countryCode;

          countryDropdown.style.display = "none";
          countryDropdown.classList.remove("dropdownActive");
        });

        countryDropdown.appendChild(countryItem);
      });
    } catch (err) {
      console.error("Failed to load countries:", err);
    }
  }
  countryButton.addEventListener("click", () => {
    const isVisible = countryDropdown.style.display === "block";
    countryDropdown.style.display = isVisible ? "none" : "block";
    countryDropdown.classList.toggle("dropdownActive", !isVisible);
  });
  document.addEventListener("click", (event) => {
    if (!countryButton.contains(event.target) && !countryDropdown.contains(event.target)) {
      countryDropdown.style.display = "none";
      countryDropdown.classList.remove("dropdownActive");
    }
  });
  fetchCountries();
});


async function createSubscription() {
    const countryCodeElement = document.querySelector('#countryButton .countryCode');
    const mobileNumberInput = document.getElementById('mobileNumber');
    const mobileError = document.getElementById('mobileError');
    const emailInput = document.getElementById('email');
    const mobileNumber = mobileNumberInput.value;
    const email = emailInput.value;
    const countryCode = countryCodeElement.textContent;
    const country_code_with_phone = countryCode + mobileNumber;
    const currentUrl = window.location.href;
    const mobilePattern = /^\+(\d{1,4})(\d{7,15})$/;

    if (!country_code_with_phone) {
        mobileError.textContent = 'Please enter your phone number.';
        mobileError.style.display = 'block';
    } else if (!mobilePattern.test(country_code_with_phone)) {
        mobileError.textContent = 'Please enter a valid phone number in the format +12345678901.';
        mobileError.style.display = 'block';
    } else {
        const url = 'https://a.klaviyo.com/client/subscriptions?company_id=MRf2w3';
        const headers = {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            'Revision': '2024-10-15'
        };

        const body = {
            data: {
                type: 'subscription',
                attributes: {
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                email: email,
                                phone_number: country_code_with_phone,
                                locale: 'en-US',
                                properties: {
                                    $referrer: {
                                        first_page: currentUrl
                                    },
                                    $last_referrer: {
                                        first_page: currentUrl
                                    },
                                    $source: "(EN) Custom Newsletter Pop-Up"
                                }
                            }
                        },
                        meta: {
                            patch_properties: {
                                append: {
                                    // skus: '92538' // Replace this with dynamic SKU if needed
                                }
                            }
                        }
                    },
                    custom_source: 'Homepage footer signup form'
                },
                relationships: {
                    list: {
                        data: {
                            type: 'list',
                            id: 'R5NEdt'
                        }
                    }
                }
            }
        };
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body)
            });
        if (response.status == 202 ) {
          showForm(form3, form1, form2);
      }
        else if (response.status == 400) {
                const errorData = await response.json();
                const errorMessage = errorData.errors[0].detail;
                mobileError.textContent = errorMessage;
                mobileError.style.display = 'block';
            } 
        
        else {
          
          throw new Error(`HTTP error! status: ${response.status}`);
      }
        } catch (error) {
          
            console.error('Error creating subscription:', error);
        }
    }
}

async function createSubscriptionwithemail() {
  const emailInput = document.getElementById('email');
  const mobileError = document.getElementById('mobileError');
  const email = emailInput.value;
  const currentUrl = window.location.href;
  const url = 'https://a.klaviyo.com/client/subscriptions?company_id=MRf2w3';
  
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
    'Revision': '2024-10-15'
  };

  const body = {
    data: {
      type: 'subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: {
              properties: {
                email: email,
                $referrer: {
                  first_page: currentUrl
                },
                $last_referrer: {
                  first_page: currentUrl
                },
                $source: "(EN) Custom Newsletter Pop-Up"
              },
              email: email,
              locale: 'en-US'
            },
            meta: {
              patch_properties: {
                append: {
                  // skus: '92538' // Replace this with dynamic SKU if needed
                }
              }
            }
          }
        },
        custom_source: 'Homepage footer signup form'
      },
      relationships: {
        list: {
          data: {
            type: 'list',
            id: 'R5NEdt'
          }
        }
      }
    }
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body)
    });
    console.log(response)
     if (response.status == 202 ) {
          showForm(form3, form1, form2);
      }
     else if (response.status == 400) {
                const errorData = await response.json();
                const errorMessage = errorData.errors[0].detail;
                mobileError.textContent = errorMessage;
                mobileError.style.display = 'block';
            } else {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
  } catch (error) {
  }
}